module.exports = __webpack_public_path__ + "img/bz.f5812085.svg";